/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { InsuranceType } from './InsuranceType';
import {
    InsuranceTypeFromJSON,
    InsuranceTypeFromJSONTyped,
    InsuranceTypeToJSON,
    InsuranceTypeToJSONTyped,
} from './InsuranceType';

/**
 * 
 * @export
 * @interface CreatePalReauthSubmissionRequest
 */
export interface CreatePalReauthSubmissionRequest {
    /**
     * 
     */
    lead_id: string;
    /**
     * Must be greater than the lead's highest existing cycle number
     */
    cycle_number: number;
    /**
     * 
     */
    payor_id: string;
    /**
     * 
     */
    insurance_type: InsuranceType;
    /**
     * Start of the current authorization. Documents for the first cycle are collected from this date.
     */
    authorization_start_date: Date;
    /**
     * Today or later, in the facility's time zone
     */
    next_review_date: Date;
    /**
     * 
     */
    external_id?: string | null;
    /**
     * 
     */
    case_manager_id?: string | null;
    /**
     * 
     */
    level?: string | null;
}



/**
 * Check if a given object implements the CreatePalReauthSubmissionRequest interface.
 */
export function instanceOfCreatePalReauthSubmissionRequest(value: object): value is CreatePalReauthSubmissionRequest {
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('cycle_number' in value) || value['cycle_number'] === undefined) return false;
    if (!('payor_id' in value) || value['payor_id'] === undefined) return false;
    if (!('insurance_type' in value) || value['insurance_type'] === undefined) return false;
    if (!('authorization_start_date' in value) || value['authorization_start_date'] === undefined) return false;
    if (!('next_review_date' in value) || value['next_review_date'] === undefined) return false;
    return true;
}

export function CreatePalReauthSubmissionRequestFromJSON(json: any): CreatePalReauthSubmissionRequest {
    return CreatePalReauthSubmissionRequestFromJSONTyped(json, false);
}

export function CreatePalReauthSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePalReauthSubmissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_id': json['lead_id'],
        'cycle_number': json['cycle_number'],
        'payor_id': json['payor_id'],
        'insurance_type': InsuranceTypeFromJSON(json['insurance_type']),
        'authorization_start_date': (json['authorization_start_date'] == null ? json['authorization_start_date'] : parseDate(json['authorization_start_date'])),
        'next_review_date': (json['next_review_date'] == null ? json['next_review_date'] : parseDate(json['next_review_date'])),
        'external_id': json['external_id'] === undefined ? undefined : json['external_id'] === null ? null : json['external_id'],
        'case_manager_id': json['case_manager_id'] === undefined ? undefined : json['case_manager_id'] === null ? null : json['case_manager_id'],
        'level': json['level'] === undefined ? undefined : json['level'] === null ? null : json['level'],
    };
}

export function CreatePalReauthSubmissionRequestToJSON(json: any): CreatePalReauthSubmissionRequest {
    return CreatePalReauthSubmissionRequestToJSONTyped(json, false);
}

export function CreatePalReauthSubmissionRequestToJSONTyped(value?: CreatePalReauthSubmissionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_id': value['lead_id'],
        'cycle_number': value['cycle_number'],
        'payor_id': value['payor_id'],
        'insurance_type': InsuranceTypeToJSON(value['insurance_type']),
        'authorization_start_date': value['authorization_start_date'] == null ? value['authorization_start_date'] : serializeDate(value['authorization_start_date']),
        'next_review_date': value['next_review_date'] == null ? value['next_review_date'] : serializeDate(value['next_review_date']),
        'external_id': value['external_id'],
        'case_manager_id': value['case_manager_id'],
        'level': value['level'],
    };
}

